<template>
  <ul class="items" v-if="display_style == 1">
    <li
      :id="'chapter_' + chapter.id"
      class="chapter_item"
      v-for="chapter in chapters"
      :key="chapter.id"
      :class="{ chapter_expand: chapterExpand[chapter.id] }"
    >
      <div
        class="chapter_title"
        :class="{ chapter_title_expand: chapterExpand[chapter.id] }"
        @click="toggleExpand(chapter.id)"
        :title="chapter.title"
      >
        <span class="eps">{{ chapter.title }}</span>
      </div>
      <template v-if="chapter.child && chapter.child.length > 0">
        <div
          class="chapter_content"
          v-for="period in chapter.child"
          :key="period.id"
          :class="{ current: currentPeriod == period.id }"
        >
          <VideoCoursePeriod
            :period="period"
            styleClass="chapter_content_child"
            :course="course"
            :tryText="tryText"
            :isVideo="isVideo"
            :onPeriodTap="onPeriodTap"
          ></VideoCoursePeriod>
        </div>
      </template>
    </li>
  </ul>
  <div class="chapter_periods" v-else>
    <div
      class="chapter_content"
      :class="{ current: currentPeriod == period.id }"
      v-for="period in chapters"
      :key="period.id"
    >
      <VideoCoursePeriod
        :period="period"
        styleClass="chapter_content_parent"
        :course="course"
        :tryText="tryText"
        :isVideo="isVideo"
        :onPeriodTap="onPeriodTap"
      ></VideoCoursePeriod>
    </div>
  </div>
</template>
<script>
import VideoCoursePeriod from "./VideoCoursePeriod.vue";
import util from "@/utils/plugins";
export default {
  name: "VideoCourseChapter",
  components: {
    VideoCoursePeriod,
  },
  data() {
    return {
      id: "",
      type: 0,
      chapters: [],
      chapterExpand: {},
      display_style: 0,
    };
  },
  props: {
    course: {
      type: Object,
    },
    currentPeriod: {
      type: String,
    },
    tryText: {
      type: String,
      default: "试看",
    },
    // 是否来自点播页面
    isVideo: {
      type: Boolean,
      default: false,
    },
    onPeriodTap: {
      type: Function,
    },
    courseChapterDataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  async created() {},
  watch: {
    course: async function () {
      await this.getData();
    },
  },
  methods: {
    async getData() {
      this.id = this.course.id;
      this.type = this.course.course_type;
      await this.getChapter();
      if (this.currentPeriod) {
        this.chapters.forEach(c => {
          if (!c.child) {
            return;
          }
          c.child.forEach(p => {
            if (p.id == this.currentPeriod) {
              this.chapterExpand[c.id] = 1;
            }
          });
        });
      }
    },
    formatPeriod(period) {
      let that = this;
      let currentPeriod = this.currentPeriod;
      let files = [];
      if (period.datum && period.datum.length > 0) {
        period.datum.forEach(item => {
          files.push({
            file_name: item.file_name,
            ware_url: item.ware_url,
            datum_id: item.datum_id,
            fid: item.fid.split(";"),
            file_ext: util.getFileType(item.file_name),
          });
        });
      }
      period.files = files;
      console.log(currentPeriod == period.id);
      if (currentPeriod == period.id) {
        that.$emit("periodFiles", period.files);
      }
    },
    async getChapter() {
      if (!this.id) {
        return;
      }
      if (this.type == 9 || this.course.type == 4) {
        return;
      }
      let chapters = this.courseChapterDataList;
      /*
      let chapters = await this.$http.post("/api/app/courseChapter", {
        id: this.id,
      });*/
      if (chapters.length > 0) {
        if (!chapters[0].periods_title) {
          this.display_style = 1;
          chapters.forEach(c => {
            this.$set(this.chapterExpand, c.id, 0);
            if (!c.child) {
              return;
            }
            c.child.forEach(child => {
              this.formatPeriod(child);
            });
          });
        } else {
          if (this.type != 3) {
            chapters = chapters.filter(c => c.parent_id != 0);
          }
          chapters.forEach(c => {
            this.formatPeriod(c);
          });
        }
      }
      this.chapters = chapters;
    },
    toggleExpand(id) {
      for (let key in this.chapterExpand) {
        if (key == id) {
          continue;
        }
        this.chapterExpand[key] = 0;
      }
      if (this.chapterExpand[id] == 0) {
        this.chapterExpand[id] = 1;
      } else {
        this.chapterExpand[id] = 0;
      }
      this.$emit("chapterClick", id);
    },
    getNextPeriod(id) {
      let chapters = this.chapters;
      if (!chapters[0].periods_title) {
        chapters = chapters.filter(c => c.child && c.child.length > 0);
        let c, p;
        let chapter;
        for (c = 0; c < chapters.length; c++) {
          chapter = chapters[c];
          if (!chapter.child) {
            return;
          }
          for (p = 0; p < chapter.child.length; p++) {
            let period = chapter.child[p];
            if (period.id == id) {
              break;
            }
          }
          if (p == chapter.child.length) {
            continue;
          }
          let nextPeriod = chapter.child[p + 1];
          if (nextPeriod) {
            return nextPeriod;
          }
          let nextChapter = chapters[c + 1];
          if (!nextChapter) {
            return;
          }
          return nextChapter.child[0];
        }
      } else {
        let i;
        for (i = 0; i < chapters.length; i++) {
          let chapter = chapters[i];
          if (chapter.id == id) {
            break;
          }
        }
        return chapters[i + 1];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.chapter_periods {
  width: 410px;
  float: left;
  .chapter_content {
    width: 410px;
    float: left;
    font-size: 12px;
    color: #ccc;
  }
  .current {
    background-color: #222121;
    color: #f25130;
  }
}
.items {
  width: 410px;
  float: left;
  color: #ccc;
  font-size: 12px;
  .chapter_item {
    width: 100%;
    float: left;
    .chapter_title {
      width: 100%;
      float: left;
      cursor: pointer;
      position: relative;
      padding: 0px 20px;
      height: 30px;
      line-height: 30px;
      box-sizing: border-box;
      &::before {
        background: url(~@/assets/images/video/lesson_icon_pullup.png) no-repeat
          50% 50%;
        background-size: auto 6px;
        content: "";
        width: 10px;
        height: 30px;
        float: left;
        margin-right: 10px;
      }
      .eps {
        float: left;
        width: calc(100% - 20px);
      }
    }
    .chapter_content {
      display: none;
      width: 410px;
      float: left;
      font-size: 12px;
      color: #ccc;
    }
    .current {
      background-color: #222121;
      color: #f25130;
    }
  }
  .chapter_expand {
    .chapter_content {
      display: block;
    }
    .chapter_title_expand {
      &::before {
        background: url(~@/assets/images/video/lesson_icon_pulldown.png)
          no-repeat 50% 50% !important;
        background-size: auto 6px !important;
      }
    }
  }
}
</style>
